// src/utils/schemas/telefone.ts
import { z } from "zod";

export function normalizarTelefone(telefone: string): string {
  return telefone.replace(/\D/g, "");
}

/// Fonte única de verdade para o formato de telefone.
// Aceita SOMENTE DDD + número: 10 dígitos (fixo) ou 11 (celular).
// Não há DDI: o telefone é um identificador interno da aplicação.
export function isTelefoneValido(phone: string): boolean {
  const digits = normalizarTelefone(phone);
  return digits.length === 10 || digits.length === 11;
}

// Normalização canônica do telefone: apenas dígitos, sem DDI.
// Isomórfica: cadastro, edição e login usam exatamente esta regra.
export const phoneNumberSchema = z
  .string()
  .trim()
  .min(1, "O telefone é obrigatório.")
  .transform(normalizarTelefone)
  .refine(
    (digits) => isTelefoneValido(digits),
    "Informe DDD + número (fixo: 10 dígitos, celular: 11 dígitos). Ex: 51999815888.",
  );
